import { createContext, useContext, useState } from 'react';

/**
 * Describes which visual implementation descendants should render.
 *
 * More fields can be added as migration needs grow without changing the
 * provider or hook API.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_TRELLIS_MIGRATION_CONTEXT = {
  isTrellisEnabled: false
};
const TrellisMigrationContext = /*#__PURE__*/createContext(DEFAULT_TRELLIS_MIGRATION_CONTEXT);
/**
 * Makes a stable Trellis migration decision available to a subtree.
 *
 * The value is copied and captured when this provider mounts. Updating the
 * `value` prop does not switch an already-mounted subtree between visual
 * implementations.
 */
export function TrellisMigrationProvider({
  value,
  children
}) {
  const [initialValue] = useState(() => Object.assign({}, value));
  return /*#__PURE__*/_jsx(TrellisMigrationContext.Provider, {
    value: initialValue,
    children: children
  });
}

/**
 * Returns the migration decision from the nearest provider.
 *
 * Components outside a provider receive the safe Foundations default of
 * `{ isTrellisEnabled: false }`.
 */
export function useTrellisMigration() {
  return useContext(TrellisMigrationContext);
}